import React from "react";
import { Link } from "react-router-dom";
import Banner from "../props/heading";

export default function Work() {
    return (
        <>
            <div className="workMain">
                <div className="mainPart">
                    <Banner 
                        heading="heading"
                        title="title"
                        myTitle="Explore My Journey in Code and Creativity"
                        paragraph="paragraph"
                        mission="mission"
                        myMission="Full-stack web developer skilled in problem-solving, UI/UX design, and coding with JavaScript, Python, React, Node.js, and MongoDB."
                    /> 
                </div>

                <div className="workPage">
                    <div className="project-categories">
                        {/* Web Development Tile */}
                        <Link to="/web-projects" className="category-tile web-tile">
                            <div className="tile-content">
                                <div className="tile-header">
                                    <div className="tile-icon">
                                        <svg viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M12 3L1 9l11 6 9-4.91V17h2V9M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/>
                                        </svg>
                                    </div>
                                    <h2>Web Development Projects</h2>
                                </div>
                                <p>Explore my frontend and fullstack projects built with JavaScript, React, and more</p>
                                <div className="tile-footer">
                                    <span>View Projects</span>
                                    <div className="tile-arrow">→</div>
                                </div>
                            </div>
                        </Link>

                        {/* Python Tile */}
                        <Link to="/python-projects" className="category-tile python-tile">
                            <div className="tile-content">
                                <div className="tile-header">
                                    <div className="tile-icon">
                                        <svg viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M19.14 7.5A2.86 2.86 0 0122 10.36v3.78A2.86 2.86 0 0119.14 17H16v1.68a2.86 2.86 0 01-2.86 2.86H9.54l-2.39 1.68-.13.09h-.05l-.22-.15-.12-.08-.01-.01A2.86 2.86 0 014.5 19.14v-3.78A2.86 2.86 0 017.36 12.5H12v-1H4.86A2.86 2.86 0 012 8.64V4.86A2.86 2.86 0 014.86 2h3.78A2.86 2.86 0 0111.5 4.86V12h1V7.36A2.86 2.86 0 0115.36 4.5h3.78A2.86 2.86 0 0122 7.36V7.5h-2.86z"/>
                                        </svg>
                                    </div>
                                    <h2>Python Projects</h2>
                                </div>
                                <p>Discover my Python applications and problem-solving projects</p>
                                <div className="tile-footer">
                                    <span>View Projects</span>
                                    <div className="tile-arrow">→</div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}